<template>
  <div class="project">

    <h3>{{project.name}}</h3>

    <v-tabs background-color="transparent" class="tabs" v-model="activeTab" grow>
      <v-tab v-for="tab of tabs" :key="tab.id" :to="tab.route" exact>
        {{ tab.name }}
      </v-tab>
    </v-tabs>

    <router-view></router-view>

  </div>
</template>

<script>

export default {
  name: 'Project',
  props: ['accountId', 'projectId'],
  data() {
    return {
      activeTab: `/projects/${this.projectId}`,
      tabs: [
        { id: 1, name: "Overview", route: { name: 'overview', params: { accountId: this.accountId, projectId: this.projectId } } },
        { id: 3, name: "Entities", route: { name: 'entities', params: { accountId: this.accountId, projectId: this.projectId } } },
        { id: 4, name: "Pages", route: { name: 'pages', params: { accountId: this.accountId, projectId: this.projectId } } },
        { id: 5, name: "History", route: { name: 'history', params: { accountId: this.accountId, projectId: this.projectId } } },
        { id: 2, name: "Settings", route: { name: 'edit', params: { accountId: this.accountId, projectId: this.projectId } } }
      ]
    };
  },

  mounted () {
    this.$store.dispatch('projects/getProject', { id: this.projectId })
  },

  computed: {

    project () {
      return this.$store.state.projects.details[this.projectId] || {}
    }

  }

}

</script>

<style scoped>

.tabs { border-bottom: 1px solid #c1c1c1; }

</style>
